import React from 'react';
import {ReactComponent as Like} from '../assets/icons/like.svg';
import {ReactComponent as LikeFill} from '../assets/icons/likeFill.svg';
import {ReactComponent as DisLike} from '../assets/icons/dislike.svg';
import {ReactComponent as DisLikeFill} from '../assets/icons/dislikeFill.svg';
import {useMutation} from "@tanstack/react-query";
import {request} from "../lib/request";
import {Spinner} from "@heroui/react";
import {getErrorMessage, toastError, toastSuccess} from "../lib/toast";

const LikeDislike = ({e, refetch, justView}) => {
    const {mutate, isPending} = useMutation({
        mutationFn: async data => (
            await request({
                url: `/restaurant/toggle/${e.id}?is_like=${data}`,
                method: 'post',
                data
            })
        ),
        onSuccess: data => {
            toastSuccess(data.message, {title: 'ثبت شد'});
            refetch()
        },
        onError: err => {
            toastError(getErrorMessage(err));
        }
    })
    return (
        <>
            {isPending ? <Spinner variant="wave"/> : <div
                className="flex items-center gap-2 text-gray-600 text-sm">
                <div className="center cursor-pointer" onClick={justView ? () => {
                } : () => mutate(1)}>{e.is_liked ?
                    <LikeFill className="fill-success_main"/> : <Like/>}</div>
                <div className="">({e.likesCount})</div>
                <div className="center cursor-pointer" onClick={justView ? () => {
                } : () => mutate(0)}>{e.is_disliked ?
                    <DisLikeFill className="fill-error_main"/> : <DisLike/>}</div>
                <div className="">({e.dislikesCount})</div>
            </div>}
        </>
    );
};
export default LikeDislike;